const inspections = [
    {
        "uuid": "1",
        "inspectionYear": 2022,
        "inspectionSeason": "Q3",
        "appType": "followUp",
        "area": "北區",
        "companyName": "中農粉絲有限公司",
        "assessmentPlace": "花蓮廠",
        "assessmentPlaceLocation": "新北市/五股區",
        "projectManager": "王小花",
    },
    {
        "uuid": "2",
        "inspectionYear": 2022,
        "inspectionSeason": "Q3",
        "appType": "followUp",
        "area": "北區",
        "companyName": "源天然股份有限公司",
        "assessmentPlace": "宜蘭廠",
        "assessmentPlaceLocation": "台中市/萬里區",
        "projectManager": "李小白",
    },
    {
        "uuid": "3",
        "inspectionYear": 2022,
        "inspectionSeason": "Q3",
        "appType": "renewal",
        "area": "中區",
        "companyName": "豆之家食品有限公司",
        "assessmentPlace": "彰化廠",
        "assessmentPlaceLocation": "台中市/大里區",
        "projectManager": "陳小飛",
    },
]

export default inspections;